import { supabase } from './supabase';

/**
 * Sign up a new user with email and password.
 * @param {string} email
 * @param {string} password
 * @param {'practitioner' | 'client' | 'assistant'} role
 * @param {object} metadata - Additional user metadata (name, invite_code, etc.)
 */
export async function signUp(email, password, role, metadata = {}) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        role,
        ...metadata,
      },
    },
  });
  return { data, error };
}

/**
 * Sign in with email and password.
 */
export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  return { data, error };
}

/**
 * Sign out the current user.
 */
export async function signOut() {
  const { error } = await supabase.auth.signOut();
  return { error };
}

/**
 * Get the current session.
 */
export async function getSession() {
  const { data, error } = await supabase.auth.getSession();
  return { session: data?.session, error };
}

/**
 * Get the current user.
 */
export async function getUser() {
  const { data, error } = await supabase.auth.getUser();
  return { user: data?.user, error };
}

/**
 * Listen for auth state changes.
 */
export function onAuthStateChange(callback) {
  return supabase.auth.onAuthStateChange(callback);
}
